import { ShieldCheck } from "lucide-react";

/**
 * Pill badge rendered when the user has saved a VALID emergency preparedness
 * card. Visual contract: dark green bg + bright green text.
 */
export function PreparedBadge({ compact = false, className = "", testId = "prepared-badge" }) {
  return (
    <span
      className={`badge-prepared ${compact ? "badge-prepared-compact" : ""} ${className}`}
      data-testid={testId}
      title="Tu ficha de emergencia está lista para usar en situaciones críticas."
      aria-label="Preparado para emergencia"
    >
      <ShieldCheck size={compact ? 10 : 12} strokeWidth={2.6} aria-hidden="true" />
      <span>✓ Preparado para emergencia</span>
    </span>
  );
}
